import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import InputField from "components/UI/InputField";
import toast from "react-hot-toast";
import { PanelSchema } from "validation/schema/panel.schema";
import FileUpload from "components/UI/FileUpload";
import { axiosSakusas } from "common/api/axios/sakusas_axios";
import { FILE_UP_NAME } from "common/constants";

type PanelUploadProps = {
  fileUploadHandle: Function;
  fileNameDefault?: string;
};

const PanelUpload = ({
  fileUploadHandle,
  fileNameDefault,
}: PanelUploadProps) => {
  //   const onSubmit = async (data: any) => {
  //     console.log(data);

  //     toast.success("New panel added");
  //   };
  //   const fileUploadHandle = (upRes: any) => {
  //     console.log("fileUploadHandle", upRes);
  //   };
  const uploadUrl = "panel/up";

  return (
    <DivUpload>
      <FileUpload
        axiosInstance={axiosSakusas}
        fileFieldName={FILE_UP_NAME}
        fileUploadHandle={fileUploadHandle}
        uploadUrl={uploadUrl}
        showUploadedFile
        fileNameDefault={fileNameDefault}
      />
    </DivUpload>
  );
};

const DivUpload = styled.div`
  display: flex;
`;

export default PanelUpload;
